<template>
  <div class="iq-button">
    <div class="d-flex align-center iq-btn-gap">
      <EXTooltip
        title="Get Started with exlQtive"
        placement="right"
        :children="true"
        :delay="300"
      >
        <div
          class="iq-logo-wrapper"
          @mouseenter="isHovered = true"
          @mouseleave="isHovered = false"
          slot="icon"
          @click="handleClick"
        >
          <Icon
            v-if="!shouldPulse && size === 'large'"
            name="iq_large_icon"
            class="iq-logo"
          />
          <Icon
            v-if="!shouldPulse && size === 'small'"
            name="iq_small_icon"
            class="iq-logo-small"
          />
          <svg
            v-if="shouldPulse"
            class="hover-icon"
            width="36"
            height="35"
            viewBox="0 0 36 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="4" y="3.5" width="28" height="27.7379" rx="5.25" fill="#ED2738"/>
            <rect x="2.30948" y="1.80948" width="31.381" height="31.119" rx="6.94052" stroke="#ED2738" stroke-opacity="0.25" stroke-width="3.38104"/>
            <path d="M26.3447 17.0625C26.3447 18.6971 25.8279 20.1154 24.7942 21.3173L26.0923 22.6694L24.3255 24.2379L22.9553 22.8137C21.9818 23.3545 20.9241 23.625 19.7822 23.625C17.9673 23.625 16.4229 22.9939 15.1488 21.7319C13.8748 20.4579 13.2378 18.9014 13.2378 17.0625C13.2378 15.2235 13.8748 13.6731 15.1488 12.4111C16.4229 11.137 17.9673 10.5 19.7822 10.5C21.5971 10.5 23.1416 11.137 24.4156 12.4111C25.7017 13.6731 26.3447 15.2235 26.3447 17.0625ZM19.7822 21.1911C20.251 21.1911 20.7197 21.1129 21.1885 20.9567L19.1152 18.7932L20.882 17.2247L23.0995 19.5324C23.6043 18.8113 23.8567 17.988 23.8567 17.0625C23.8567 15.8606 23.4661 14.869 22.6849 14.0877C21.9036 13.3065 20.9361 12.9159 19.7822 12.9159C18.6284 12.9159 17.6609 13.3065 16.8796 14.0877C16.0984 14.869 15.7077 15.8606 15.7077 17.0625C15.7077 18.2524 16.0984 19.238 16.8796 20.0192C17.6609 20.8004 18.6284 21.1911 19.7822 21.1911Z" fill="white"/>
            <path d="M9 10.7539H11.488V23.3741H9V10.7539Z" fill="white"/>
          </svg>
        </div>
      </EXTooltip>
      <v-img v-if="logoShow" :src="require('@components/assets/new-logo.svg')" contain />
      <div v-if="textShow" class="text-label">{{ textLabel }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits } from 'vue';
import Icon from "@components/icons/Icon.vue";
import EXTooltip from "@components/tooltip/EXTooltip.vue";

const emit = defineEmits(['click']);

const props = defineProps({
  logoShow: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "large",
  },
  countNewMsg: {
    type: Number,
    default: 0,
  },
  textShow: {
    type: Boolean,
    default: false,
  },
  textLabel: {
    type: String,
    default: "",
  }
});

const isHovered = ref(false);
const shouldPulse = computed(() => isHovered.value || props.countNewMsg > 0);

const handleClick = () => {
  emit('click');
};
</script>

<style scoped>
.iq-button {
  display: flex;
  align-items: center;
  gap: 8px;
}

.iq-btn-gap {
  display: flex;
  align-items: center;
  gap: 3px;
}

.iq-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 35px;
  line-height: 0;
}

.iq-logo {
  margin: 0;
}

.iq-logo-small {
  margin: 0;
}

.hover-icon {
  animation: pulse 1.5s infinite;
}

.text-label {
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #344054;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
